import { create } from "zustand";
import { persist } from "zustand/middleware";

export type DateFormat = "relative" | "absolute";

interface PrefsState {
  /** IANA timezone, e.g. "Europe/Paris". Falls back to the browser default. */
  timezone: string;
  date_format: DateFormat;
  language: string;
  setTimezone: (tz: string) => void;
  setDateFormat: (f: DateFormat) => void;
  setLanguage: (lang: string) => void;
}

function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

export const usePrefsStore = create<PrefsState>()(
  persist(
    (set) => ({
      timezone: browserTimezone(),
      date_format: "relative",
      language: "en",
      setTimezone: (tz) => set({ timezone: tz }),
      setDateFormat: (f) => set({ date_format: f }),
      setLanguage: (lang) => set({ language: lang }),
    }),
    { name: "prism.prefs" },
  ),
);
